import React from 'react';
import PriceTag from './PriceTag';

function priceTone(changePct) {
    if (typeof changePct === 'number' && changePct < 0) return 'bg-[#FF6B6B0D] border-[#FFC4C4]';
    if (typeof changePct === 'number' && changePct > 0) return 'bg-[#34D3990D] border-[#AEEDD6]';
    return 'bg-[#F3F4F6] border-[#EDEFF3]';
}

export default function PriceBadge({ price, changePct, compact = true, className = '' }) {
    if (price === null && changePct === null) return null;
    return (
        <div className={`${priceTone(changePct)} ${className}`}>
            <PriceTag price={price} changePct={changePct} compact={compact} />
        </div>
    );
}
